import { render, staticRenderFns } from "./ItemScLBarcode.vue?vue&type=template&id=b7a70e24"
import script from "./ItemScLBarcode.vue?vue&type=script&lang=js"
export * from "./ItemScLBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports